import {
  ThemeProvider,
  styled,
  SingleDisclaimer,
} from '@volkswagen-onehub/components-core';
import {Disclaimer} from '@volkswagen-onehub/disclaimer-manager';
import * as React from 'react';

export interface DisclaimerLayerContentProps {
  readonly closeButton: React.ReactNode;
  readonly disclaimer: Disclaimer;
}

const closeButtonHeight = '44px';

const StyledCloseButtonWrapper = styled.div`
  position: sticky;
  top: ${(props) => props.theme.size.static100};
  right: ${(props) => props.theme.size.static100};
  margin-top: ${(props) => props.theme.size.static100};
  margin-right: ${(props) => props.theme.size.static100};
  margin-bottom: ${(props) =>
    `calc(-1 * (${props.theme.size.static100} + ${closeButtonHeight}))`};
  text-align: right;
`;

const StyledDisclaimerWrapper = styled.div`
  padding-top: ${(props) => props.theme.size.static250};
  padding-right: 52px;
  padding-bottom: ${(props) => props.theme.size.static250};
  padding-left: ${(props) => props.theme.size.static250};
  hyphens: auto;
`;

export function DisclaimerLayerContent({
  closeButton,
  disclaimer,
}: DisclaimerLayerContentProps): JSX.Element {
  return (
    <ThemeProvider theme="inverted">
      <StyledCloseButtonWrapper>{closeButton}</StyledCloseButtonWrapper>
      <StyledDisclaimerWrapper>
        <SingleDisclaimer disclaimer={disclaimer} hasReferences={true} />
      </StyledDisclaimerWrapper>
    </ThemeProvider>
  );
}
